module cr.events {
    class ResultController {

        static $inject = ['eventView', 'ResultService', 'reportList','$scope', '$stateParams', '$modal','$state'];


        SelectResult(result)
        {
            //console.log("Select Result"+angular.toJson(result));
            switch (result.ReportType.toLowerCase()){
                case "link":
                    break;

                case "time":
                case "xml":
                    this.$state.go("event.reports.group.report",{reportId: result.Id});
                    break;

/*                case "xml":
                    window.location.href="https://prod.chronorace.be/Classements/classement.aspx?eventId="+this.$stateParams["eventId"]+"&mode=large&idClassement="+result.Id;
                    break;*/

                case "file":
                    /*switch (result.Settings.FileType.toLowerCase()){
                    }*/
                    window.location.href="https://crdev.blob.core.windows.net/files/"+result.Settings.FileName;
                    break;


                default:
                    return "fa fa-chevron-right";
            }
        }

        GetIcon(result)
        {
            switch (result.ReportType){
                case "Link":
                    return "fa fa-external-link";

                case "File":
                    switch (result.Settings.FileType.toLowerCase()){
                        case "pdf":
                            return "fa fa-file-pdf-o";

                        case "xls":
                            return "fa fa-file-excel-o";

                        default:
                            return "fa fa-file-o";
                    }
                    break;

                default:
                    return "fa fa-chevron-right";

            }
        }

        constructor(private eventView, private resultService:IResultService, reportList:any, private $scope, private $stateParams, private $modal,private $state) {
            $scope.eventView = eventView;
            $scope.reportList = reportList;

            $scope.GetIcon=r=>this.GetIcon(r);
            $scope.SelectResult=r=>this.SelectResult(r);

            $scope.options={ enabled:false };

            $scope.SetPage=page=>{
                resultService.searchReport(this.$stateParams['eventId'],$scope.curReport.Id,$scope.search,(page-1)*25,25).then(data=>{
                    $scope.results=data;
                });

            }

            $scope.globalSearch=srch=>{
                console.log("Global Search: "+srch);
                resultService.eventSearch(this.$stateParams['eventId'],srch,0,100).then(data=>{
                    //console.log("res: "+angular.toJson(data));
                    this.$scope.globalResult=data;
                });
            }

            $scope.closeGlobalResult=()=>{
                this.$scope.globalResult=null;
                this.$scope.srch="";

            }

            $scope.globalSearchAction=(action,data)=>
            {
                switch (action)
                {
                    case "master":
                    case "select":
                        console.log("globalSearchAction: "+angular.toJson(action)+","+angular.toJson(data));
                        console.log("wtf: "+angular.toJson({ groupId: data["sH_Group"],reportId:data["sH_Report"]}));
                        $state.go("event.reports.group.report", { groupId: data["sH_Group"],reportId:data["sH_Report"]})
                        break;

                    default:
                        break;
                }

            }

            $scope.getOverviewClass=row=>{
                if (row.Gender=="F") return "table-row-girl";
                return "";
            }

            $scope.SearchResult=(toSearch)=>{
                console.log("search: "+toSearch);
                $scope.curPage=1;
                resultService.searchReport(this.$stateParams['eventId'],$scope.curReport.Id,toSearch,0,25).then(data=>{
                    $scope.results=data;
                });

            }

            $scope.groupId=this.$stateParams['groupId'];

            if ($scope.groupId){
                $scope.curGroup=_.find(reportList,g=>(<any>g).Id==$scope.groupId);
            }

            $scope.search="";

            $scope.reportId=this.$stateParams['reportId'];
            if ($scope.reportId){
                $scope.curReport=_.find($scope.curGroup.Reports,r=>(<any>r).Id==$scope.reportId);
            }

            switch ($state.current.name)
            {
                case "event.reports.home":
                    if (reportList.length==1){
                        $state.go("^.group.home", { groupId: reportList[0].Id })
                    }
                    break;

                case "event.reports.group.home":
                    //$scope.curReport=$scope.curGroup.
                    if ($scope.curGroup.Reports.length==1){
                        console.log("only 1 report... redirect");
                        this.SelectResult($scope.curGroup.Reports[0]);
                    }

                    break;

                case "event.reports.group.report":
                    if ($scope.curReport)
                    {
                        console.log("ici, zen: "+this.$stateParams['reportId']+"/"+this.$stateParams['eventId']);
                        resultService.searchReport(this.$stateParams['eventId'],$scope.curReport.Id,$scope.search,0,25).then(data=>{
                            $scope.results=data;
                        });

                    }
                    break;

                default:
                    console.log($state.current.name);
                    break;
            }


        }
    }

    eventModule
        .controller('resultController', ResultController);

}
